import {useMutation, useQueryClient} from "react-query";
import axios from "services/axios";

// Dummy actions; replace with axios when API ready
const delay = ms => new Promise(res => setTimeout(res, ms));

export function useGenerateApiKey() {
	const queryClient = useQueryClient();

	return useMutation(
		async ({staffId, label}) => {
			const {data} = await axios.post(`/staff/${staffId}/api-keys`, {label});

			return data;
		},
		{
			onSuccess: (_data, variables) => {
				const {staffId} = variables || {};

				if (staffId) {
					queryClient.invalidateQueries(["staffApiKeys", staffId]);
					queryClient.removeQueries(["staffApiKeys", staffId]);
				}
			},
		},
	);
}

export function useDeleteApiKey() {
	const queryClient = useQueryClient();

	return useMutation(
		async ({staffId, apiKeyId}) => {
			const {data} = await axios.delete(`/staff/${staffId}/api-keys/${apiKeyId}`);

			return data;
		},
		{
			onSuccess: (_data, variables) => {
				const {staffId} = variables || {};

				if (staffId) {
					queryClient.invalidateQueries(["staffApiKeys", staffId]);
					queryClient.removeQueries(["staffApiKeys", staffId]);
				}
			},
		},
	);
}

export function useToggleApiKeyStatus() {
	const queryClient = useQueryClient();

	return useMutation(
		async ({id, status}) => {
			await delay(200);

			return {success: true};
			// return axios.post('/api-keys/toggle', {id, status})
		},
		{
			onSuccess: () => {
				queryClient.invalidateQueries("apiKeyList");
				queryClient.removeQueries("apiKeyList");
			},
		},
	);
}

export function useUpdateApiKey() {
	const queryClient = useQueryClient();

	return useMutation(
		async ({id, name}) => {
			await delay(250);

			return {success: true};
			// return axios.post('/api-keys/update', {id, name})
		},
		{
			onSuccess: () => {
				queryClient.invalidateQueries("apiKeyList");
				queryClient.removeQueries("apiKeyList");
			},
		},
	);
}

export function useRegenerateApiKey() {
	const queryClient = useQueryClient();

	return useMutation(
		async ({id}) => {
			await delay(300);

			return {success: true, data: {id, key: "pk_live_DUMMYREGENERATEDKEY"}};
			// return axios.post('/api-keys/regenerate', {id})
		},
		{
			onSuccess: () => {
				queryClient.invalidateQueries("apiKeyList");
				queryClient.removeQueries("apiKeyList");
			},
		},
	);
}
